import { UsersDBSearchParams } from '@/enitites/user'
import { useInfiniteQuery, useQuery } from '@tanstack/vue-query'
import { userKeys } from '@/enitites/user/api/keys'
import { getPublicUsers, getUserById } from '@/enitites/user/api/service'
import { computed, ComputedRef } from 'vue'

export const useUsersInfiniteQuery = (params: UsersDBSearchParams) => {
  return useInfiniteQuery({
    queryKey: userKeys.list(params),
    queryFn: getPublicUsers,
    initialPageParam: 0,
    getNextPageParam: (lastPage, _, lastPageParam) => {
      if (lastPage.length === params.pageSize) {
        return Number(lastPageParam) + 1
      }
      return undefined
    },
  })
}

export const useUserQuery = (userId: ComputedRef<number | undefined>) => {
  return useQuery({
    queryKey: computed(() => userKeys.detail(userId)),
    queryFn: (context) => {
      const [, , userIdFromKey] = context.queryKey
      if (!userIdFromKey) return null
      // @ts-expect-error ignore
      return getUserById(context)
    },
  })
}
